import './PartialProgressBar.scss'

type Props = {
  progress: number
}

export const PartialProgressBar = ({ progress }: Props) => {
  return (
    <div className="partial-progress-bar">
      <div className="partial-progress-bar-fill" style={{ width: `${progress}%` }} />
    </div>
  )
}
